import { Routes } from '@angular/router';
import { MainLayoutComponent } from './core/layout/main-layout/main-layout.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { LoginComponent } from './features/auth/login/login.component';
import { CaseEnquiryComponent } from './features/case-enquiry/case-enquiry.component';
import { AddCaseEnquiryComponent } from './features/case-enquiry/add-case-enquiry/add-case-enquiry.component';
import { AttorneyComponent } from './features/attorney/attorney.component';
import { CasesComponent } from './features/cases/cases.component';
import { AddCaseDetailsComponent } from './features/cases/add-case-details/add-case-details.component';
import { CaseDetailsComponent } from './features/cases/case-details/case-details.component';
import { AssistantCasesComponent } from './features/assistant-cases/assistant-cases.component';
import { NotificationSettingsComponent } from './features/notification-settings/notification-settings.component';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';

export const routes: Routes = [
    {
        path: '',
        component: LoginComponent,
        canActivate: [guestGuard]
    },
    {
        path: 'client-form/:token',
        loadComponent: () =>
            import('./features/client-form/client-form.component').then(m => m.ClientFormComponent),
    },
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [authGuard],
        children: [
            { path: 'dashboard', component: DashboardComponent, data: { breadcrumb: 'Dashboard' } },
            {
                path: 'case-enquiry',
                data: { breadcrumb: 'Case Inquiry' },
                children: [
                    { path: '', component: CaseEnquiryComponent },
                    { path: 'add', component: AddCaseEnquiryComponent, data: { breadcrumb: 'Add Inquiry' } }
                ]
            },
            { path: 'attorney', component: AttorneyComponent, data: { breadcrumb: 'Attorney' } },
            { path: 'notification-settings', component: NotificationSettingsComponent, data: { breadcrumb: 'Notification Settings' } },
            {
                path: 'cases',
                data: { breadcrumb: 'Cases' },
                children: [
                    { path: '', component: CasesComponent },
                    { path: 'add-details', component: AddCaseDetailsComponent, data: { breadcrumb: 'Add Case Details' } },
                    { path: ':id', component: CaseDetailsComponent, data: { breadcrumb: 'Case Details' } }
                ]
            },
            {
                path: 'assistant-cases',
                children: [
                    { path: '', component: AssistantCasesComponent },
                    { path: ':id', component: CaseDetailsComponent }
                ]
            }
        ]
    },
    {
        path: '**',
        redirectTo: ''
    }
];
